import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import React, { useImperativeHandle, forwardRef, useEffect } from 'react';
import styled from 'styled-components';
import { UrlInput, UrlList } from './components';
import { useImportUrl } from './import-url.hook';
import { Spin } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Container = styled.div.withConfig({
  displayName: "import-urlcontainer__Container",
  componentId: "sc-13s6ecv-0"
})(["display:flex;flex-direction:column;height:100%;"]);
var ErrorMessage = styled.div.withConfig({
  displayName: "import-urlcontainer__ErrorMessage",
  componentId: "sc-13s6ecv-1"
})(["color:#ff4d4f;font-size:12px;margin-top:8px;text-align:center;"]);
var LoadingOverlay = styled.div.withConfig({
  displayName: "import-urlcontainer__LoadingOverlay",
  componentId: "sc-13s6ecv-2"
})(["display:flex;align-items:center;justify-content:center;padding:20px;border:2px dashed #d1d5db;border-radius:8px;background-color:#f9fafb;min-height:80px;flex-direction:column;gap:8px;"]);
var LoadingText = styled.div.withConfig({
  displayName: "import-urlcontainer__LoadingText",
  componentId: "sc-13s6ecv-3"
})(["color:#6b7280;font-size:14px;font-weight:500;"]);
export var ImportUrlContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var allowedFileTypes = _ref.allowedFileTypes,
      fileSizeLimitMb = _ref.fileSizeLimitMb,
      totalSizeLimitMb = _ref.totalSizeLimitMb,
      disabled = _ref.disabled,
      hideUrlInput = _ref.hideUrlInput,
      fileSelector = _ref.fileSelector,
      maxFileUpload = _ref.maxFileUpload,
      onStateChange = _ref.onStateChange;
  var importUrlHook = useImportUrl(allowedFileTypes, fileSizeLimitMb, totalSizeLimitMb);
  useEffect(function () {
    onStateChange === null || onStateChange === void 0 ? void 0 : onStateChange();
  }, [importUrlHook.urls.length, importUrlHook.isValidating, onStateChange]);
  useImperativeHandle(ref, function () {
    return {
      getUrls: function getUrls() {
        var urls = importUrlHook.urls.map(function (url) {
          return url.url;
        });

        if (allowedFileTypes) {
          return urls.filter(function (url) {
            return allowedFileTypes.some(function (ext) {
              return url.toLowerCase().split('?')[0].endsWith(ext.toLowerCase());
            });
          });
        }

        return urls;
      },
      clear: function clear() {
        importUrlHook.clearUrls();
      },
      hasValidUrls: importUrlHook.urls.length > 0 && (!allowedFileTypes || importUrlHook.urls.some(function (url) {
        return allowedFileTypes.some(function (ext) {
          return url.url.toLowerCase().split('?')[0].endsWith(ext.toLowerCase());
        });
      })),
      isValidating: importUrlHook.isValidating
    };
  }, [importUrlHook, importUrlHook.urls, importUrlHook.isValidating, allowedFileTypes]);

  var handleAddUrl = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return importUrlHook.addUrl(importUrlHook.inputValue);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleAddUrl() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleRemoveUrl = function handleRemoveUrl(urlId) {
    importUrlHook.removeUrl(urlId);
  };

  return /*#__PURE__*/_jsxs(Container, {
    children: [hideUrlInput || importUrlHook.urls.length > 0 ? null : importUrlHook.isValidating ? /*#__PURE__*/_jsxs(LoadingOverlay, {
      children: [/*#__PURE__*/_jsx(Spin, {
        size: "small"
      }), /*#__PURE__*/_jsx(LoadingText, {
        children: "Validating URL..."
      })]
    }) : /*#__PURE__*/_jsx(UrlInput, {
      value: importUrlHook.inputValue,
      onChange: importUrlHook.handleInputChange,
      onAdd: handleAddUrl,
      disabled: disabled || importUrlHook.isValidating,
      loading: importUrlHook.isValidating,
      allowedFileTypes: allowedFileTypes
    }), /*#__PURE__*/_jsx(UrlList, {
      urls: importUrlHook.urls,
      onRemove: handleRemoveUrl
    }), importUrlHook.error && /*#__PURE__*/_jsx(ErrorMessage, {
      children: importUrlHook.error
    })]
  });
});
ImportUrlContainer.displayName = 'ImportUrlContainer';